// Interruption handling (design §4.5): no manual pause button. The overlay
// appears on visibilitychange and hands control back after a 3-2-1 countdown.

import { t } from '../i18n';
import { el, enter } from './dom';

export interface PauseHandle {
  /** Runs the 3-2-1 countdown, then removes the overlay. */
  resume(onTick?: (n: number) => void): Promise<void>;
  /** Removes the overlay without counting down. */
  dismiss(): void;
}

export function showPause(root: HTMLElement): PauseHandle {
  const number = el('div', { class: 'countdown-number', text: '' });
  const screen = el('div', { class: 'screen screen--pause' }, [
    el('div', { class: 'intro-line', text: t('pause.title') }),
    el('div', { class: 'intro-sub', text: t('pause.body') }),
    number,
  ]);
  root.append(screen);
  enter(screen);

  let cancelled = false;

  return {
    dismiss(): void {
      cancelled = true;
      screen.remove();
    },
    async resume(onTick?: (n: number) => void): Promise<void> {
      for (let n = 3; n >= 1; n--) {
        if (cancelled) return;
        number.textContent = String(n);
        onTick?.(n);
        await wait(650);
      }
      if (cancelled) return;
      number.textContent = t('countdown.go');
      onTick?.(0);
      await wait(280);
      screen.remove();
    },
  };
}

function wait(ms: number): Promise<void> {
  return new Promise((r) => setTimeout(r, ms));
}
